import { render } from "./GalleryStatisticsComponent.vue?vue&type=template&id=2be117b6&ts=true"
import script from "./GalleryStatisticsComponent.vue?vue&type=script&lang=ts"
export * from "./GalleryStatisticsComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__